<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind2.set(title[2]);
            ind3 = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            ind1 = uplotnenie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            webtype.set(webtypes.find((el) => item.title.toLowerCase().includes(el.toLowerCase())));
            count.set(+item.quantity);
            comment.set(item.comment);
            fetchData = await fetch($ind2);
            change();
        }
    };

    const otkrivanie = [
        'Створка влево',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка вправо',
        'Створка от краев к середине'
    ];

    const uplotnenie = [
        'Без уплотнения',
        'Щеточный',
        'Магнитный'
    ];

    const color = options.color || {
        'Антрацит': 'Антрацит',
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Цветной': 'Цветной',
    };

    const webtypes = options.webtype || [
        'Обычная',
    ];

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Slim', '', color);
        let options = await network.fetch_ind('Slim');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '2000'),
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание
        ind1 = 'Щеточный', // уплотнитель
        webtype = parameter('webtype', 'Обычная'), // тип сетки плиссе
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let result = {
            type: 'slim',
            name: 'Slim',
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', $webtype, ' ', ind1
            ].join(''),
            title: [
                'Slim', ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', $webtype, ' ', ind1
            ].join(''),
            params: {
                ind1: ind1,
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 22
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамы slim')) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                    case 'Створка от краев к середине':
                        kolvo = (((w - 30) * 2 + (h - 50) * 2) / 1000).toFixed(3);
                        break;


                    case 'Створка вертикал':
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = (((w - 50) * 2 + (h - 30) * 2) / 1000).toFixed(3);
                        break;
                }
            }

            if (name.includes('профиль створки slim')
                || (name.includes('магнит') && ind1.toLowerCase().includes('магнит'))
                || (name.includes('еточный') && ind1.toLowerCase().includes('еточный'))) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        kolvo = ((h - 58) / 1000).toFixed(3);
                        break;

                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 58) / 1000).toFixed(3);
                        break;

                    case 'Створка от краев к середине':
                        kolvo = ((h - 58) * 2 / 1000).toFixed(3);
                        break;
                }
            }

            // системе СЛИМ при расчете  объема сетки (полотна) в кол-ве волн нужно увеличить на 10% (с округлением в большую сторону)

            if (name.includes('сетка мс плиссе')) {
                switch (true) {
                    case $webtype === 'Обычная' && (name.includes('антипыль') || name.includes('антикошка')):
                        return;

                    case $webtype === 'Антипыль' && !name.includes('антипыль'):
                        return;

                    case $webtype === 'Антикошка' && !name.includes('антикошка'):
                        return;
                }

                let k = 1;
                if (name.includes('антипыль') || name.includes('антикошка')) {
                    k = 1.1;
                }

                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        wave = Math.ceil(w * 55 / 1100);
                        kolvo = (((h - 35) / 1000 * wave * 0.034)*1.1 * k).toFixed(4);
                        break;
                    case 'Створка от краев к середине':
                        wave = Math.ceil(w * 55 / 1100);
                        kolvo = (((h - 35) / 1000 * wave * 0.034)*1.1 * k).toFixed(4);
                        break;

                    default:  //Створка вертикал
                        wave = Math.ceil(h * 55 / 1100);
                        kolvo = (((w - 35) / 1000 * wave * 0.034)*1.1 * k).toFixed(3);
                        break;
                }
            }

            if (name.includes('лента со скотчем')) {
                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        kolvo = ((h - 35) / 1000 * 2).toFixed(3);
                        break;
                    case 'Створка от краев к середине':
                        kolvo = ((h - 35) / 1000 * 2* 2).toFixed(3);
                        break;

                    default:  //'Створка вертикал
                        kolvo = ((w - 35) / 1000 * 2).toFixed(3);
                        break;
                }
            }

            let c, k;
            switch (ind3) {
                case 'Створка влево':
                case 'Створка вправо':
                case 'Створка от краев к середине':
                    k = h;
                    break;

                default:  //'Створка вертикал
                    k = w;
                    break;
            }

            if (name.includes('нить мс плиссе')) {


                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        k = h;
                        switch (true) {
                            case (k - 50 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 50 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 50 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        kolvo = (((w + h) * 2 + 300) / 1000 * c).toFixed(3);

                        break;

                    case 'Створка от краев к середине':
                        k = h;
                        switch (true) {
                            case (k - 50 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 50 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 50 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        kolvo = 2 * (((w + h) * 2 + 300) / 1000 * c).toFixed(3);

                        break;


                    default:  //'Створка вертикал
                        k = w;

                        switch (true) {
                            case (k - 30 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 30 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 30 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        kolvo = (((w + h) * 2 + 300) / 1000 * c).toFixed(3);
                        break;
                }


            }
            if (name.includes('пятка')) {
                kolvo = (2).toFixed(3);

                switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = (kolvo * 2).toFixed(3);
                        break;
                }
            }
            if (name.includes('угол')) {
                kolvo = (4).toFixed(3);
            }
            if (name.includes('работа')) {
                kolvo = 1;
            }

            if (name.includes('заглушка ')) {
                kolvo = (4).toFixed(3);

            }

            if (name.includes('гвозд')) {
                kolvo = 2;
                switch (ind3) {
                    case 'Створка от краев к середине':
                        kolvo = (kolvo * 2).toFixed(3);
                        break;
                }
            }

            if (name.includes('пвх заглушка')) {
                kolvo = 4;
            }

            if (name.includes('заклеп')) {

                let c, k;
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        k = h;

                        switch (true) {
                            case (k - 58 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 58 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 58 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        break;

                    case 'Створка от краев к середине':
                        k =   h;

                        switch (true) {
                            case (k - 58 - 100) < 1200: {
                                c =2 * 2;
                                break;
                            }
                            case (k - 58 - 100) <= 1600: {
                                c = 2 *3;
                                break;
                            }
                            case (k - 58 - 100) <= 2300: {
                                c =2 * 4;
                                break;
                            }
                            default: {
                                c = 2 *5;
                                break;
                            }
                        }
                        break;
                    default:  //'Створка вертикал
                        k = w;

                        switch (true) {
                            case (k - 30 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 30 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 30 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        break;
                }


                kolvo = c * 4;
            }


            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('упаковка')) {
                packing_items.push(item);
            }

        }, 250);

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000 });
        dispatch('item', result);
    });

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center  text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each otkrivanie as item}
                                        <option value="{item}"  >{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Ширина, мм ≥ { options.recomend && options.recomend.width ? options.recomend.width : 1000 }</label>
                                <input type="number" class="form-control text-center { $width > (options.recomend && options.recomend.width ? options.recomend.width : 1600) ? 'text-danger' : '' }" step="10" min="300" max="{ options.max && options.max.width ? options.max.width : 1000 }" bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Высота, мм ≥ { options.recomend && options.recomend.height ? options.recomend.height : 2200 }</label>
                                <input type="number" class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 2200) ? 'text-danger' : '' }" step="10" min="300" max="{ options.max && options.max.height ? options.max.height : 2200 }" bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип сетки</label>
                                <select class="form-control form-select" bind:value={$webtype} >
                                    {#each webtypes as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Уплотнитель</label>
                                <select class="form-control form-select" bind:value={ind1}>
                                    <option value="Без уплотнения">Без уплотнения</option>
                                    <option value="Щеточный">Щеточный</option>
                                    <option value="Магнитный">Магнитный</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3" src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
